import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { services } from "@/services/registry";
export function usePasswordReset() {
    const forgotPasswordMutation = useMutation({
        mutationFn: (email)=>services.passwordResetService.forgotPassword({
                email
            }),
        onError: ()=>{
        // Forgot password error occurred
        }
    });
    const confirmForgotPasswordMutation = useMutation({
        mutationFn: (data)=>services.passwordResetService.confirmForgotPassword(data),
        onError: ()=>{
        // Confirm forgot password error occurred
        }
    });
    const resendCodeMutation = useMutation({
        mutationFn: (email)=>services.passwordResetService.resendConfirmationCode({
                email
            }),
        onError: ()=>{
        // Resend code error occurred
        }
    });
    const getErrorMessage = (error)=>{
        if (error instanceof AxiosError) {
            const errorResponse = error.response?.data;
            return errorResponse?.message || "An unexpected error occurred";
        } else if (error instanceof Error) {
            return error.message;
        }
        return "An unexpected error occurred";
    };
    return {
        forgotPasswordResponse: forgotPasswordMutation.data?.data,
        // State
        state: {
            isLoading: forgotPasswordMutation.isPending || confirmForgotPasswordMutation.isPending || resendCodeMutation.isPending,
            error: forgotPasswordMutation.error || confirmForgotPasswordMutation.error || resendCodeMutation.error ? getErrorMessage(forgotPasswordMutation.error || confirmForgotPasswordMutation.error || resendCodeMutation.error) : null,
            success: confirmForgotPasswordMutation.data?.data.message || resendCodeMutation.data?.data.message || forgotPasswordMutation.data?.data.message || null,
            isCodeSent: forgotPasswordMutation.isSuccess
        },
        // Actions
        forgotPassword: async (email)=>{
            await forgotPasswordMutation.mutateAsync(email);
        },
        confirmForgotPassword: async (data)=>{
            await confirmForgotPasswordMutation.mutateAsync(data);
        },
        resendCode: async (email)=>{
            await resendCodeMutation.mutateAsync(email);
        },
        clearMessages: ()=>{
            forgotPasswordMutation.reset();
            confirmForgotPasswordMutation.reset();
            resendCodeMutation.reset();
        },
        reset: ()=>{
            forgotPasswordMutation.reset();
            confirmForgotPasswordMutation.reset();
            resendCodeMutation.reset();
        }
    };
}
